import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { useI18N } from "@sundae/react-hooks";
import { Balance, Text, Tooltip } from "@sundae/ui-toolkit";
import { FC, memo, useMemo } from "react";
import { useCurrentTasteTestContribution } from "../../../hooks/taste-test/useCurrentTasteTestContribution";
import { useTasteTestContext } from "../../../pages/TasteTestDetail/context";
import { useProfileAppContext } from "../../../stores";

const TasteTestDepositOutput: FC = () => {
  const { currentLocale, t } = useI18N("taste-test");
  const {
    state: { privacyEnabled },
  } = useProfileAppContext();
  const currentContribution = useCurrentTasteTestContribution();
  const {
    derived: { depositAssetAmount },
    state: { actionType, tasteTest },
  } = useTasteTestContext();
  const total = useMemo(() => {
    return depositAssetAmount?.add(currentContribution);
  }, [currentContribution, depositAssetAmount]);

  return (
    <>
      <div className="z-10 inline-block">
        <Text className="inline" tag="span" size="2xl">
          {t("preview.deposit.youWillDeposit", {
            context: actionType === "update" ? "update" : undefined,
          })}{" "}
        </Text>
        <div className="inline-flex">
          <Balance
            abbreviate={false}
            gradient
            locale={currentLocale}
            showSymbol
            size="2xl"
            value={depositAssetAmount}
          />
        </div>{" "}
        <Text className="inline" tag="span" size="2xl">
          {t("preview.deposit.toTasteTest")}.{" "}
          {t("preview.deposit.newTotalDeposit", {
            poolName: `ADA-${tasteTest?.asset.ticker}`,
            context: actionType === "update" ? "update" : undefined,
          })}{" "}
        </Text>
        {actionType === "update" && (
          <>
            <div className="inline-flex">
              <Balance
                abbreviate={false}
                gradient
                locale={currentLocale}
                privacy={privacyEnabled}
                showSymbol
                size="2xl"
                value={total}
              />
            </div>
            <Tooltip
              trigger={
                <div className="inline">
                  {" "}
                  <InformationCircleIcon className="inline-block h-6 w-6 cursor-help align-sub" />
                </div>
              }
              tooltipLabel="Current Deposit"
            />
          </>
        )}
      </div>
    </>
  );
};

export default memo(TasteTestDepositOutput);
